import React from 'react'
import * as E from './footerImageElements'
import Dude from './../../../images/steve.png'
import Car from './../../../images/car_with_line.png'

export const FooterImageStyled = () => {
    return <E.FooterImageDiv> 
        <E.FooterImageContainer>
            <img src={Dude} />
            <img src={Car}/>
        </E.FooterImageContainer>
    </E.FooterImageDiv>
}
